import { createApi } from '@reduxjs/toolkit/query/react';
import { identityBaseQuery } from '../../lib/axiosBaseQuery';

export const usersApi = createApi({
  reducerPath: 'usersApi',
  baseQuery: identityBaseQuery,
  tagTypes: ['Users', 'Roles'],
  endpoints: (builder) => ({
    getUsers: builder.query<any, void>({
      query: () => ({
        url: `Users/list`,
        method: 'GET',
      }),
      providesTags: ['Users'],
    }),
    createUser: builder.mutation<void, Record<string, any>>({
      query: (data) => ({
        url: `Users/create-user`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Users'],
    }),
    getRoles: builder.query<any, void>({
      query: () => ({
        url: `Users/roles`,
        method: 'GET',
      }),
      providesTags: ['Roles'],
    }),
    updateUser: builder.mutation<void, Record<string, any>>({
      query: (data) => ({
        url: `Users/update-user`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Users'],
    }),
    deleteUser: builder.mutation<void, string>({
      query: (id) => ({
        url: `Users/remove/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Users'],
    }),
  }),
});

export const {
  useGetUsersQuery,
  useCreateUserMutation,
  useGetRolesQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
} = usersApi;
